// @ts-strict

import { Component, OnInit, Input } from '@angular/core';
import { CampaignDetailsService } from '@app/core/services/campaign-details/campaign-details.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-program-conditions',
  templateUrl: './program-conditions.component.html',
  styleUrls: ['./program-conditions.component.scss']
})
export class ProgramConditionsComponent implements OnInit {
  @Input() restrictions: Record<string, string>[] = [];
  @Input() campaignID?: number;

  public panelLanguage = '';
  public Object = Object;
  public isLoaded = false;

  private availableTextLanguages: string[] = [];

  constructor(private campaignDetails: CampaignDetailsService, private translate: TranslateService) {}

  ngOnInit(): void {
    if (!this.restrictions) {
      this.campaignDetails.getCampaignsDetails(this.campaignID || 0).subscribe(res => {
        this.restrictions = res.data?.campaign?.restriction || [];
        this.checkForCurrentLangOrSetEnglish();
      });
    } else {
      this.checkForCurrentLangOrSetEnglish();
    }
  }

  private checkForCurrentLangOrSetEnglish(): void {
    this.restrictions?.map(restriction => {
      this.availableTextLanguages.push(Object.keys(restriction).toString());
    });
    this.panelLanguage = this.translate.currentLang;
    if (!this.availableTextLanguages.includes(this.panelLanguage)) {
      this.panelLanguage = 'en';
    }
    this.isLoaded = true;
  }
}
